import { ROUTE } from '../../routes';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { api } from '../../configs/api';
import { getAppHeader } from '../../configs/config';
import { DigioKycStatus } from '../../configs/constants';
import { WIDGET } from '@voltmoney/schema';
import { nextStepCredStepper, ShowNewMandateError } from '../../configs/utils';
import SharedPropsService from '../../SharedPropsService';
let pollInterval;
let responseFromDigio;
let isPopupShown = false;
let hasNavigated = false;
let isSuccessShow = false;
let currentStepId;
let stepStatusMap;
let isRejected = false;
let isCallbackCalled = false;
export const GoToNumber = async (action, _datastore, { navigate, goBack }) => {
    // await goBack();
    await AsyncStorage.setItem('first_time', 'true');
    navigate(ROUTE.SPLASH_SCREEN);
};
export const closeModal = async (action, _datastore, { goBack, showPopup, navigateWithClear }) => {
    await navigateWithClear(ROUTE.DIGIO_MANDATE_SIGN, {
        mandateCancelled: true,
        mandateSuccess: false,
        mandateFailed: false,
    });
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    isRejected = false;
    await hidePopup();
};
export const successVerification = async (action, _datastore, { goBack, navigateToBase, navigateWithClear, network }) => {
    hasNavigated = true;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    await SharedPropsService.setUser(userContextResponse.data);
    const routeObj = await nextStepCredStepper(currentStepId, stepStatusMap);
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const digioCallback = async (action, datastore, { network, navigateToBase, navigateWithClear, removeWidgets, hidePopup }) => {
    isRejected = true;
    responseFromDigio = action.payload;
    const type = action.payload.type;
    const error = action.payload.error;
    let isPopupShown = false;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : userContextResponse.data.linkedApplications[0].applicationId;
    if (action?.payload.type !== isSuccessShow && !isPopupShown) {
        if (action.payload.type === 'success') {
            isSuccessShow = true;
        }
        const show_new_mandate_error_flow = await ShowNewMandateError();
        console.log('show_new_mandate_error_flow', show_new_mandate_error_flow);
        await network
            .get(show_new_mandate_error_flow
            ? `${api.digioMandateCheckRequestStatusOnCallBackV2}${applicationId}`
            : `${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(async (response) => {
            const status = show_new_mandate_error_flow
                ? response?.data?.stepResponseObject?.status
                : response?.data?.stepResponseObject;
            // ------ MANDATE NEW ERROR FLOW ------ //
            if (show_new_mandate_error_flow &&
                response?.status === 200 &&
                status !== DigioKycStatus.COMPLETED) {
                const errorData = response?.data?.stepResponseObject?.error;
                await navigateToBase(ROUTE.DIGIO_MANDATE_SIGN, {
                    mandateFailed: false,
                    mandateCancelled: false,
                    mandateSuccess: false,
                    showExtraMandateError: true,
                    mandateErrorData: errorData
                });
                return;
                // ------------------------------- //
            }
            else if (response.status === 200 &&
                status === DigioKycStatus.COMPLETED) {
                currentStepId = response.data.updatedApplicationObj.currentStepId;
                stepStatusMap = response.data.updatedApplicationObj.stepStatusMap;
                const routeObj = await nextStepCredStepper(currentStepId, stepStatusMap);
                !hasNavigated && setTimeout(() => {
                    navigateWithClear(routeObj.routeId, routeObj.params);
                }, 4000);
                await navigateWithClear(ROUTE.DIGIO_MANDATE_SIGN, {
                    mandateSuccess: true,
                    mandateCancelled: false,
                    mandateFailed: false,
                });
            }
            if (error === 'User%20Cancelled%20The%20Transaction' && !isPopupShown) {
                isPopupShown = true;
                await removeWidgets(ROUTE.MANDATE_MODAL, [{ id: "digio", type: WIDGET.KYC_DIGIO_MANDATE }]);
                await navigateWithClear(ROUTE.DIGIO_MANDATE_SIGN, {
                    mandateFailed: true,
                    mandateCancelled: false,
                    mandateSuccess: false,
                });
            }
            else if (type === 'cancel') {
                await removeWidgets(ROUTE.MANDATE_MODAL, [{ id: "digio", type: WIDGET.KYC_DIGIO_MANDATE }]);
                isPopupShown = true;
                await navigateWithClear(ROUTE.DIGIO_MANDATE_SIGN, {
                    mandateCancelled: true,
                    mandateSuccess: false,
                    mandateFailed: false
                });
            }
        });
    }
};
